// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import {
  BundleMemberInput,
  BundleResponse,
  bundleResponseSchema,
} from '@/bundle/api/types';

/**
 * Parameters for replacing a bundle's member list.
 */
interface UpdateBundleMembersParameters {
  members: BundleMemberInput[];
}

/**
 * Replaces the member list for a bundle.
 * Returns the updated bundle including its members.
 */
export async function updateBundleMembers(
  key: string,
  parameters: UpdateBundleMembersParameters
): Promise<BundleResponse> {
  const url = `/v1/catalog/bundle/${key}/members`;
  const response = await api.patch(url, parameters);
  return parseResponse(bundleResponseSchema, response.data, {
    schemaName: 'UpdateBundleMembers',
    endpoint: url,
  });
}
